import React, {useState, useEffect, useRef, useCallback} from "react";
import { Link } from "react-router-dom";
import useGetSubjectList from "../hooks/useGetSubjectList";
import Footer from "../components/Footer";
import axiosapi from "../api/axiosapi";
import useAuth from "../hooks/useAuth";

const MathSubjectList = () => {
    const [pageNumber, setPageNumber] = useState(1)
    const { loading, error, hasMore, subjectList } = useGetSubjectList(pageNumber)
    const [randomString, setRandomString] = useState();
    const {auth, setAuth} = useAuth();
    const [loading2, setLoading2] = useState(true);
    const observer = useRef()

    const lastProblemElementRef = useCallback(node => {
        if (loading) return
        if (observer.current) observer.current.disconnect()
        observer.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setPageNumber(prevPageNumber => prevPageNumber + 1)
            }
            })
        if (node) observer.current.observe(node)
    }, [loading, hasMore])

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading2(false);
            }
        }
        !auth?.accessToken && fetchToken();
        
        const randomAlphabetString = () => {
            const letters = '1234567890';
            let randomStringl = '';
            for (let i = 0; i < 39; i++) {
                randomStringl += letters[Math.floor(Math.random() * letters.length)];
            }
            setRandomString(randomStringl);
        };
        randomAlphabetString();
    },[])

    return(
        <div className="vertical-flex-container-1">
            <div className="content-box-1">
                <div className="card-list-title">
                    <p className="title">체계적으로 도전하기</p>
                </div>
            </div>
            <div className="content-box-1">
                <div className="card-container">
                    {/* <div className="containerListItem">
                        <div className="subjectCards"> */}
                            {console.log("subjectList: ",subjectList)}
                            {subjectList.map((subject, index) => {
                                if(subjectList.length === index+1) {
                                    return (
                                        <div ref={lastProblemElementRef} key={subject.id} className="card">
                                            <h4>{subject.goodApproachTitle}</h4>
                                            <p>{subject.goodApproachDescription}</p>
                                            <p>{subject.publicationDate}</p>
                                            <Link 
                                                to={`/mathsubject/${randomString}`}
                                                state={{
                                                    "subjectCode": subject.subjectCode,
                                                    "problemCode": subject.firstProblemCode,
                                                    "subjectTitle": subject.goodApproachTitle
                                                }}
                                            >
                                                참여하기...
                                            </Link>
                                        </div>
                                    )
                                } else {
                                    return (
                                        <div key={subject.topCategory} className="card">
                                            <h4>{subject.goodApproachTitle}</h4>
                                            <p>{subject.goodApproachDescription}</p>
                                            <p>{subject.publicationDate}</p>
                                            <Link 
                                                to={`/mathsubject/${randomString}`}
                                                state={{
                                                    "subjectCode": subject.subjectCode,
                                                    "problemCode": subject.firstProblemCode,
                                                    "subjectTitle": subject.goodApproachTitle
                                                }}
                                            >
                                                참여하기...
                                            </Link>
                                        </div>
                                    )
                                }
                            })}
                        {/* </div> */}
                        <div>{loading && 'Loading...'}</div>
                        <div>{error && 'Error'}</div>
                    {/* </div> */}
                    {/* <div className="containerListItem">
                        <div className="rightSideMenuList">
                            <div className="rightSideMenuListItem">
                                <SideMenu />
                            </div>
                            <div className="rightSideMenuListItem">
                                풀지 못했던 문제
                            </div>
                            <div className="rightSideMenuListItem">
                                부담없이 도전하기
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            <div style={{width: "100%"}}>
                <Footer/>
            </div>
        </div>
    );
}

export default MathSubjectList;